var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCartRepeatBlack = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 18C6.9 18 6.01 18.9 6.01 20C6.01 21.1 6.9 22 8 22C9.1 22 10 21.1 10 20C10 18.9 9.1 18 8 18ZM18 18C16.9 18 16.01 18.9 16.01 20C16.01 21.1 16.9 22 18 22C19.1 22 20 21.1 20 20C20 18.9 19.1 18 18 18ZM8.17 14.75L8.2 14.63L9.1 13H16.55C17.3 13 17.96 12.59 18.3 11.97L22.16 4.96L20.42 4H20.41L19.31 6L16.55 11H9.53L9.4 10.73L7.16 6L6.21 4L5.27 2H2V4H4L7.6 11.59L6.25 14.04C6.09 14.32 6 14.65 6 15C6 16.1 6.9 17 8 17H20V15H8.42C8.29 15 8.17 14.89 8.17 14.75Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 9.50004C11.4267 9.50004 10.1372 8.29046 10.0103 6.75004C10.0035 6.66761 10 6.58424 10 6.50006H10.75C10.75 6.50005 10.75 6.50007 10.75 6.50006H10C10 6.50007 10 6.50005 10 6.50006C10 8.15756 11.3425 9.50004 13 9.50004ZM15.25 6.50006C15.25 6.50005 15.25 6.50007 15.25 6.50006V6.50006ZM15.2274 6.18054C15.0836 5.17155 14.2685 4.37676 13.25 4.26382C13.1679 4.25471 13.0845 4.25004 13 4.25004C14.1328 4.25004 15.0719 5.09023 15.2274 6.18054ZM13.25 6.35359V4.51557C14.2355 4.63889 15 5.48151 15 6.50004C15 7.60322 14.1032 8.50004 13 8.50004C11.8968 8.50004 11 7.60322 11 6.50004V6.25004H9.75V6.50004C9.75 8.29561 11.2044 9.75004 13 9.75004C14.7956 9.75004 16.25 8.29561 16.25 6.50004C16.25 4.78859 14.9287 3.38706 13.25 3.2595V1.39648L10.7714 3.87504L13.25 6.35359Z",
    fill: "#333333"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCartRepeatBlack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CartRepeatBlack.5cfa2b35.svg";
export { ForwardRef as ReactComponent };